import React from 'react';
import PropTypes from 'prop-types';
import CalendarButtonIcon from './CalendarButtonIcon';

const CalendarOptionButton = ({
  title,
  onClick,
  isOpen,
  className,
  ...props
}) => {
  const style = {
    transform: isOpen && 'rotate(0.5turn)'
  };

  return (
    <div
      className={className}
      onKeyPress={onClick}
      onClick={onClick}
      role='presentation'
      type='button'
      {...props}
    >
      {title}
      <CalendarButtonIcon style={style} className='ml-1x' />
    </div>
  );
};

CalendarOptionButton.defaultProps = {
  isOpen: false,
  title: 'select'
};

CalendarOptionButton.propTypes = {
  title: PropTypes.string,
  onClick: PropTypes.func,
  isOpen: PropTypes.bool,
  className: PropTypes.string
};

export default CalendarOptionButton;
